import {
  getNewsById,
  getNews
} from '~api/news'

export const state = () => ({
  allNews: [],
  pages: {},
  currentNewsDetails: {}
})

export const getters = {
  allNewsGetter: state => state.allNews,
  pageGetter: state => state.pages,
  currentNewsDetailsGetter: state => state.currentNewsDetails
}

export const actions = {
  async getNewsAll ({ commit }, {
    type,
    page
  }) {
    const data = await getNews({
      type,
      page
    })
    const {
      news,
      pages
    } = data
    commit('setAllNews', news)
    commit('setAllNewsPage', pages)
    return data
  },
  async getNewsDetailsById ({
    commit
  }, id) {
    const news = await getNewsById(id)
    commit('setCurrentNewsDetails', news)
  }
}

export const mutations = {
  setAllNews (state, payload) {
    state.allNews = payload
  },
  setAllNewsPage (state, payload) {
    state.pages = payload
  },
  setCurrentNewsDetails (state, payload) {
    state.currentNewsDetails = payload
  }
}
